module.exports = __webpack_public_path__ + "static/wiz3-a60f192f302df1e67f6330c4961f4f08.jpg";